const routes = {
  suppliers: 'ציים'
};

export default routes;